import * as ReactDOMClient from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import App from './App';
import { TokenBridge } from './components/TokenBridge';
import './index.scss';

const rootElement = document.getElementById('root');
const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string;

const root = ReactDOMClient.createRoot(rootElement!);
root.render(
  <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/">
    <TokenBridge />
    <App />
  </ClerkProvider>,
);
